import { type FilesViewerProps } from '../FilesViewer';

/** This component can display a plain text file */
export default function TxtViewer({ fileEncoded }: FilesViewerProps) {
	const text = atob(fileEncoded);
	return <p>{text}</p>;
}
